var _ref2, _ref3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13.7,
    height: 16.677,
    viewBox: "0 0 13.7 16.677",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip-path"
  }, React.createElement("rect", {
    id: "Rectangle_3469",
    "data-name": "Rectangle 3469",
    width: 13.7,
    height: 16.677,
    fill: "none"
  })))), _ref3 || (_ref3 = React.createElement("g", {
    id: "Group_10740",
    "data-name": "Group 10740",
    transform: "translate(0 0)"
  }, React.createElement("g", {
    id: "Group_10739",
    "data-name": "Group 10739",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, React.createElement("path", {
    id: "Path_28068",
    "data-name": "Path 28068",
    d: "M13.346,15.436H3.487a1.112,1.112,0,0,1-1.112-1.112V1.487A1.112,1.112,0,0,1,3.487.375h9.859a1.112,1.112,0,0,1,1.112,1.112V14.323a1.112,1.112,0,0,1-1.112,1.112",
    transform: "translate(-0.979 -0.155)",
    fill: "#d6cece"
  }), React.createElement("path", {
    id: "Rectangle_3467",
    "data-name": "Rectangle 3467",
    d: "M1.892,0h8.3a1.892,1.892,0,0,1,1.892,1.892V13.17a1.891,1.891,0,0,1-1.891,1.891h-8.3A1.892,1.892,0,0,1,0,13.169V1.892A1.892,1.892,0,0,1,1.892,0Z",
    transform: "translate(1.396 0.22)",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("path", {
    id: "Path_28069",
    "data-name": "Path 28069",
    d: "M11.346,17.436H1.487A1.112,1.112,0,0,1,.375,16.323V3.487A1.112,1.112,0,0,1,1.487,2.375h9.859a1.112,1.112,0,0,1,1.112,1.112V16.323a1.112,1.112,0,0,1-1.112,1.112",
    transform: "translate(-0.155 -0.979)",
    fill: "#fff"
  }), React.createElement("path", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    d: "M1.892,0h8.3a1.892,1.892,0,0,1,1.892,1.892V13.17a1.891,1.891,0,0,1-1.891,1.891h-8.3A1.892,1.892,0,0,1,0,13.169V1.892A1.892,1.892,0,0,1,1.892,0Z",
    transform: "translate(0.22 1.396)",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x2: 7.28,
    transform: "translate(2.622 13.233)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    x2: 7.28,
    transform: "translate(2.622 13.233)",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    x2: 7.28,
    transform: "translate(2.622 7.354)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x2: 7.28,
    transform: "translate(2.622 7.354)",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  }), React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    x2: 7.28,
    transform: "translate(2.622 10.293)",
    fill: "#fff"
  }), React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    x2: 7.28,
    transform: "translate(2.622 10.293)",
    fill: "none",
    stroke: "#2e2e2d",
    strokeWidth: 0.75
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.25ae85dd.svg";
export { ForwardRef as ReactComponent };